exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.PolarisVue-CollapseTransition--show {\n  transition: height 0.5s;\n}\n.PolarisVue-CollapseTransition--hide {\n  height: 0;\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["/home/kiran-price/_polaris_vue/live/src/components/transitions/CollapseTransition.vue"],"names":[],"mappings":";AAAA;EACE,wBAAwB;CAAE;AAE5B;EACE,UAAU;EACV,iBAAiB;CAAE","file":"CollapseTransition.vue","sourcesContent":[".PolarisVue-CollapseTransition--show {\n  transition: height 0.5s; }\n\n.PolarisVue-CollapseTransition--hide {\n  height: 0;\n  overflow: hidden; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-99631868","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/transitions/CollapseTransition.vue
// module id = 317
// module chunks = 0